'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1a-3Ml6W0wHU3ISZG8idSFnyUzBbk2VRIuSBJE4RURq8';